/**
 * @prettier
 */

import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Tag } from '@zola/zola-ui/src/components/Tag';
import { getActiveMediumData } from '../../../../reducers/pdp/selectors';
import OptionSection from '../../../CardDetail/OptionSection/OptionSection';
import styles from './styles.module.less';

const DETAILS = {
  'cotton-fluorescent': {
    image: './fake-asset.jpg', // TODO: get true asset
    description: 'Feels like an extra thick postcard with a soft, almost fabric-like surface',
    imageLabel: '',
    hasDetails: true,
  },
};

export const LetterpressPaperOptionBase = ({
  activeMediumData,
  hideDetails,
  hideOptionsOnMobile,
}) => {
  const imageTag = (
    <div className={styles.imageTagBox}>
      <Tag className={styles.imageTag}>Letterpress Exclusive</Tag>
    </div>
  );

  if (
    !activeMediumData ||
    !activeMediumData.available_options ||
    !activeMediumData.available_options['paper-type']
  ) {
    return null;
  }

  const options = activeMediumData.available_options['paper-type'].options.map(option => {
    return {
      ...option,
      ...(DETAILS[option.value] || {}),
      ...(hideDetails ? { hasDetails: false } : {}),
      imageTag,
    };
  });

  if (options.length < 1) {
    return null;
  }

  const selection = options[0];

  return (
    <div className={cx(styles.box, { [styles.hideOptionsOnMobile]: hideOptionsOnMobile })}>
      <OptionSection
        title="Paper Type"
        options={options}
        selection={selection}
        setOptionValue={() => {}}
        currentLabel={selection.label}
        optionType="paper-type"
        titleLinkAction={() => {}}
        isLinkHidden
      />
    </div>
  );
};

export const mapStateToProps = state => ({
  activeMediumData: getActiveMediumData(state),
});

export default connect(mapStateToProps)(LetterpressPaperOptionBase);
